import styled from "styled-components";

import log from '@/images/month-log-btn.png'
import presenter from '@/images/month-presenter-btn.png'
import discount from '@/images/vip-discount.png'
import discountHover from '@/images/vip-discount-hover.png'
import origin from '@/images/vip-origin.png'
import originHover from '@/images/vip-origin-hover.png'

const View = styled.div`
  position: absolute;
  left: 0;
  top: 1287px;
  width: 100%;
  height: 340px;
  text-align: center;

  .tip1 {
    font-size: 14px;
    line-height: 22px;
    color: #003d73;
    position: absolute;
    width: 100%;
    left: 0;
    top: -12px;
    cursor: auto;
  }

  .tip2 {
    font-size: 16px;
    line-height: 20px;
    color: #5daff2;
    position: absolute;
    width: 100%;
    left: 0;
    top: 50px;
  }

  .tip3 {
    font-size: 14px;
    line-height: 20px;
    color: #54a5ec;
    position: absolute;
    width: 100%;
    left: 0px;
    top: -107px;
    text-align: left;
  }

  div.log {
    position: absolute;
    right: 145px;
    top: 50px;
    background-image: url(${log});
    width: 80px;
    height: 22px;
    cursor: pointer;
  }

  div.presenter {
    position: absolute;
    cursor: pointer;
    right: 50px;
    top: 50px;
    background-image: url(${presenter});
    width: 80px;
    height: 22px;
  }

  ul {
    width: 100%;
    text-align: center;

    li {
      display: inline-block;
      // width: 130px;
      margin: 90px 14px 50px;
      line-height: 28px;
      font-size: 14px;
      color: #ab4d18;

      p {
        position: relative;
        left: 0;
        margin: 0 0;
        color: #108fcf;
      }
    }
  }

  div.discount {
    position: absolute;
    bottom: 30px;
    left: 24%;
    // background-image: url(\${discount});
    // width: 168px;
    // height: 58px;
    // cursor: pointer;
    // transition: all 0.3s;
    // &:hover{
    //   background-image: url(\${discountHover});
    // }
  }
  div.origin {
    position: absolute;
    bottom: 30px;
    right: 24%;
    //background-image: url(\${origin});
    //width: 168px;
    //height: 58px;
    // cursor: pointer;
    // transition: all 0.3s;
    // &:hover{
    //   background-image: url(\${originHover});
    // }
  }
`;

export {
  View
}
